import { FunctionComponent, useMemo } from 'react'
import { ThemeProvider as EmotionThemeProvider, useTheme } from '@emotion/react'

import { theme as defaultTheme, Theme } from '@/theme'
import { objIsEmpty } from '@/utils/objIsEmpty'

interface OwnProps {
  theme: Theme
}

// TODO: adicionar um segundo contexto e provider envolvendo o EmotionThemeProvider para passar um setter para o theme via context api
export const ThemeProvider: FunctionComponent<OwnProps> = ({
  children,
  theme,
}) => {
  return (
    <EmotionThemeProvider theme={theme || defaultTheme}>
      {children}
    </EmotionThemeProvider>
  )
}

export const useThemeContext = (): Theme => {
  const contextTheme = useTheme()

  const theme = useMemo(
    () => (!objIsEmpty(contextTheme) ? contextTheme : defaultTheme),
    [contextTheme],
  )

  return theme
}
